import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Popular from "./components/Popular";
import Categories from "./components/Categories";
import Guide from "./components/Guide";
import Faq from "./components/Faq";
import { faqs } from "@/mocks/comics";

function Cta() {
  return (
    <section className="relative overflow-hidden bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary-500 to-accent-500 p-8 md:p-12">
          <div className="relative z-10 flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
            <div>
              <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
                现在就去体验更顺手的阅读
              </h2>
              <p className="mt-3 max-w-lg text-sm leading-relaxed text-background-50/90">
                双页与滚动自由切换、夜间模式护眼、目录跳转、进度记忆，打开阅读页就能立刻感受。
              </p>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row">
              <Link
                to="/reader"
                className="whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-semibold text-primary-600 transition-colors hover:bg-background-100"
              >
                打开阅读页
              </Link>
              <a
                href="#popular"
                className="whitespace-nowrap rounded-md border border-background-50/50 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
              >
                先看看作品
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function Home() {
  useEffect(() => {
    document.title =
      "MGB漫画网 - 双页/滚动阅读切换 夜间模式 目录跳转 进度记忆";
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Popular />
        <Categories />
        <Guide />
        <Faq />
        <Cta />
      </main>
      <Footer />
    </>
  );
}